import axios from './index';

/**
 * Types
 */
import type { Response } from '@/dtos/common.dto';
import type { ConfigDto, CreateConfigDto, QueryConfigDto, UpdateConfigDto } from '@/dtos/config.dto';

/**
 * APIs
 */
// 创建配置
export function cConfig(data: CreateConfigDto) {
    return axios<Response>('/v1/configs', {
        data,
        method: 'post',
    }).then((res) => res.data);
}

// 获取配置列表
export function configs(params?: QueryConfigDto) {
    return axios<Response<ConfigDto[]>>('/v1/configs', {
        method: 'get',
        params,
    }).then((res) => res.data);
}

// 获取配置详情
export function rConfig(id: string) {
    return axios<Response<ConfigDto>>(`/v1/configs/${id}`, {
        method: 'get',
    }).then((res) => res.data);
}

// 编辑配置
export function uConfig({ id, ...data }: { id: string } & UpdateConfigDto) {
    return axios<Response<ConfigDto>>(`/v1/configs/${id}`, {
        data,
        method: 'patch',
    }).then((res) => res.data);
}

// 删除配置
export function dConfig(id: string) {
    return axios<Response>(`/v1/configs/${id}`, {
        method: 'delete',
    }).then((res) => res.data);
}
